export const validateVendorPersonalInfo = (formData) => {
  let errors = {};

  // First Name Validation
  if (!formData.BusinessName.trim()) {
    errors.BusinessName = "Business Name is required.";
  }
  if (!formData.ContactName.trim()) {
    errors.ContactName = "Contact Name is required.";
  }

  if (!formData.PhoneNo || formData.PhoneNo.trim() === "") {
    errors.PhoneNo = "Phone number is required";
  } else {
    const sanitizedPhone = formData.PhoneNo.replace(/\s+/g, "");
    if (!/^\+?[1-9]\d{1,14}$/.test(sanitizedPhone)) {
      errors.PhoneNo = "Invalid phone number format";
    }
  }

  const pinCodeRegex = /^[1-9][0-9]{5}$/;
  if (!formData.Pincode.trim()) {
    errors.Pincode = "Pincode is required.";
  } else if (!pinCodeRegex.test(formData.Pincode.trim())) {
    errors.Pincode = "Enter a valid 6-digit pincode.";
  }

  if (!formData.HouseNo.trim()) {
    errors.HouseNo = "HouseNo is required.";
  }

  if (!formData.Locality.trim()) {
    errors.Locality = "Locality is required.";
  }
  if (!formData.City.trim()) {
    errors.City = "City is required.";
  }
  if (!formData.RoadName.trim()) {
    errors.RoadName = "RoadName is required.";
  }
  if (!formData.State.trim()) {
    errors.State = "State is required.";
  }
  if (!formData.RoadName.trim()) {
    errors.RoadName = "RoadName is required.";
  }
  return errors;
};
